import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Select, notification } from 'antd';
import axios from 'axios';
import { API_URL } from '../../apis/apiTipoServicios'; // Asegúrate de que la URL de tu API sea correcta
import './servicio.css';
import Servicioimg from '../../Images/hombre.jpg';

const Servicio = () => {
  const [form] = Form.useForm();
  const [tiposServicio, setTiposServicio] = useState([]); // Estado para almacenar tipos de servicio

  // Cargar tipos de servicio al montar el componente
  useEffect(() => {
    const fetchTiposServicio = async () => {
      try {
        const response = await axios.get(API_URL);
        setTiposServicio(response.data);
      } catch (error) {
        console.error('Error al cargar tipos de servicio:', error);
      }
    };

    fetchTiposServicio();
  }, []);

  const onFinish = (values) => {
    const serviciosGuardados = JSON.parse(localStorage.getItem('servicios')) || [];
    const nuevoServicio = {
      id: serviciosGuardados.length + 1, // Aquí podrías implementar una lógica más robusta para el ID
      tipo: values.tipo, // ID del tipo de servicio seleccionado
      descripcion: values.descripcion,
    };
    serviciosGuardados.push(nuevoServicio);
    localStorage.setItem('servicios', JSON.stringify(serviciosGuardados));
    
    notification.success({
      message: 'Servicio agregado',
      description: `El servicio ha sido agregado al carrito.`,
    });
    
    form.resetFields();
  };

  return (
    <section className="Servicio-container">
      <section className="Servicio-img">
        <img src={Servicioimg} alt="Servicio" />
      </section>
      <section className="Servicio-form">
        <div>
          <h2>Solicitar servicio</h2>
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Form.Item
              label="Tipo de Servicio"
              name="tipo"
              rules={[{ required: true, message: 'Por favor selecciona el tipo de servicio' }]}
            >
              <Select placeholder="Selecciona un tipo de servicio">
                {tiposServicio.map((tipo) => (
                  <Select.Option key={tipo.id} value={tipo.id}>
                    {tipo.nombre}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Descripción"
              name="descripcion"
              rules={[{ required: true, message: 'Por favor ingresa la descripción del servicio' }]}
            >
              <Input.TextArea placeholder="Detalles sobre el servicio" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
                Agregar Servicio
              </Button>
            </Form.Item>
          </Form>
        </div>
      </section>
    </section>
  );
};

export default Servicio;
